<template>
  <v-layout>
    <CustomButton
      :text="secondaryBtnText"
      :isSecondary="true"
      :icon="secondaryIcon"
      @onClick="$emit('secondaryClicked')"
    ></CustomButton>
    <CustomButton
      :text="primaryBtnText"
      :icon="primaryIcon"
      @onClick="$emit('primaryClicked')"
    ></CustomButton>
  </v-layout>
</template>

<script>
import CustomButton from './CustomButton.vue'
export default {
  name: 'ButtonGroup',
  props: {
    primaryBtnText: {
      default: 'Next',
      type: String
    },
    secondaryBtnText: {
      default: null,
      type: Boolean
    },
    primaryIcon: {
      default: 'arrow_forward',
      type: String
    },
    secondaryIcon: {
      default: 'arrow_back',
      type: String
    }
  },
  components: {CustomButton}
}
</script>



// WEBPACK FOOTER //
// src/components/parts/utils/buttons/ButtonGroup.vue